import type {AuthHydroClickAttributes} from '../../marketing-header.types'
import {PersonIcon} from '@primer/octicons-react'
import {dashboardAnalyticsEvent, signInAnalyticsEvent} from '../header-analytics'
import {AuthCTALink} from './AuthCTALink'
import styles from './AuthCTAs.module.css'

/** Dashboard CTA target, matching the legacy `href="/"`. */
const DASHBOARD_HREF = '/'

type MobileAuthActionsProps = {
  loggedIn: boolean
  loginPath: string
  hydro: AuthHydroClickAttributes
}

/**
 * Mobile-only (`< lg`) top-row auth CTA: Sign in (logged out) or Dashboard (logged in). Desktop equivalents live in
 * {@link DesktopAuthActions} inside the expanding menu.
 */
export function MobileAuthActions({loggedIn, loginPath, hydro}: MobileAuthActionsProps) {
  return (
    <div className={styles.MobileAuthAction}>
      <AuthCTALink
        href={loggedIn ? DASHBOARD_HREF : loginPath}
        variant="subtle"
        analyticsEvent={loggedIn ? dashboardAnalyticsEvent : signInAnalyticsEvent}
        hydro={hydro}
      >
        <PersonIcon size={16} aria-hidden="true" />
        <span className="visually-hidden">{loggedIn ? 'Dashboard' : 'Sign in'}</span>
      </AuthCTALink>
    </div>
  )
}
